import React, { useContext } from "react";
import Header from "./header";
import Footer from "./footer";
import Counter from "./countertext";
import { useState, useEffect } from "react";
import { PartenerSheepDeedService } from "../services/parternshipservice";
import Testimonials from "./Testimonial";
import HomeCounters from "./Homecounters";
import WhatsAppScrollButton from "./floatingwhatsApp";
import CircularScrollProgress from "./Circularprogress";
import CitySelector from "./User/CitySelectore";
import { ServicesContext } from "../services/ServicesContext";
import { handleRazorpayPayment } from "../services/handlePayment";
import AuthUser from "../services/AuthUser";
import { useNavigate } from "react-router-dom";




function Pvtltdcompanyregistration() {

   useEffect(() => {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        const parsedUser = JSON.parse(storedUser);
        setNewData((prevData) => ({
          ...prevData,
          user_name: parsedUser.name || "",
          user_email: parsedUser.email || "",
          user_contact_number: parsedUser.mobile || "",
          user_city: parsedUser.city || "",
        }));
      }
    }, []);

           const { http, token } = AuthUser();
   const navigate = useNavigate();
   const [activeQuestion, setActiveQuestion] = useState(null);

   const toggleQuestion = (questionId) => {
      setActiveQuestion((prev) => (prev === questionId ? null : questionId));
   };

   const [newData, setNewData] = useState({ user_name: '', user_email: '', user_contact_number: '', user_city: '' })


   const [errors, setErrors] = useState({});

      const { services, loading, error } = useContext(ServicesContext);  
      if (loading) {
         return <div>Loading...</div>;  // Show loading state while fetching data
     }
   
     if (error) {
          return <div>{error}</div> // Show error state if there was an issue fetching data
     }
      const service = services.find(s => s.service_id === 2);

   const validateForm = () => {
      const newErrors = {};

      if (!newData.user_name.trim()) {
         newErrors.user_name = 'Name is required.';
      } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
         newErrors.user_name = '*Name should only contain letters and spaces.';
      }


      if (!newData.user_email.trim()) {
         newErrors.user_email = 'Email is required.';
      } else if (!/\S+@\S+\.\S+/.test(newData.user_email)) {
         newErrors.user_email = 'Enter a valid email address.';
      }

       if (!newData.user_contact_number.trim()) {
         newErrors.user_contact_number = '*number is required.';
       } else if (!/^\d{10}$/.test(newData.user_contact_number)) {
         newErrors.user_contact_number = 'Enter a valid 10-digit contact number.';
       }

      if (!newData.user_city) {
         newErrors.user_city = 'City/District is required.';
      }

      setErrors(newErrors);
      return Object.keys(newErrors).length === 0; // No errors
   };



      const formPutPartenshipdeed = async (e) => {
         e.preventDefault();
             // ✅ Check if user is logged in
      // if (!token) {
      //     alert("Please log in to continue.");
      //    localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
      //    navigate('/login'); // 👈 Use this if you're using React Router
      //    return;
      // }
         if (!validateForm()) return;
       
          localStorage.setItem("bookingData", JSON.stringify(newData));

      // Navigate to checkout
      navigate('/checkout', {
         state: {
            service: service,

         }
      });
          
       };



   return (
      <div>


         <div className="hero-area10 header-background">
            <div className="container">
               <div className="row">
                  <div className="col-lg-8">
                     <div className="title title2 ">
                        <div className="headding-shape aniamtion-key-2">
                           <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                        </div>
                        <p className="pdrl-text"><img src="assets/img/image/Line.png" className="line-image" /> <span className="text-color">250k+</span> <span>People trust us</span></p>
                        <h1 className="sk-text-color">Pvt. Ltd. Company Registration</h1>
                        <p className="pdrl-text">Get Pvt. Ltd. Registration for only <span className="text-color"> Rs.{service?.price}/- </span> <span>(Govt. Fees As per actual Extra)</span></p>
                        <p className="pd-text">Government fees and stamp duties are extra. Please fill out the form to receive a detailed quote in seconds. </p>
                        <p className="pd-text text-center star-text">Within 2 Weeks <span><img className="star" src="assets/image/star.svg" alt="" /></span> Transparent Pricing <span><img className="star" src="assets/image/star.svg" alt="" /></span> No Hidden Fees.</p>
                        <div className="couter-all">

                           <div className="row package-section">
                              <p className="ps-text">Get Absolutely Free In Package</p>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box">
                                    <img src="assets/img/image/pan-tax-registration.svg" />
                                    <p>Pan & TAN Registration</p>
                                 </div>
                              </div>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box">
                                    <img src="assets/img/image/din-and-dsc-for-directors.svg" />
                                    <p>DIN and DSC for Directors</p>
                                 </div>
                              </div>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box">
                                    <img src="assets/img/image/complete-document.svg" />
                                    <p>Complete Documentation</p>
                                 </div>
                              </div>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box">
                                    <img src="assets/img/image/personal-assistance.svg" />
                                    <p>Personal Assistance</p>
                                 </div>
                              </div>
                              <div className="col-md-2 col-6 doc-icone">
                                 <div className="counter10-counter-box dis">
                                    <img src="assets/img/image/pf-and-esc-registration.svg" />
                                    <p>PF and ESIC Registration</p>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" />
                     <div className="contact3-form-all">
                        <div className="hadding7">
                           <h3> Pvt. Ltd. Company Registration
                           </h3><p className="pdrl-text">at Rs.{service?.price}/- Only <br /> <span>(Govt. Fees As per actual Extra)</span></p>
                        </div>
                        <form action="#">
                           <div className="form-input-all">
                              <div className="form-input-box">
                                 <div className="row">
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label for="">Name<span className="red">*</span></label> {errors.user_name && <p className="error-text">{errors.user_name}</p>}

                                             <input type="text" placeholder="Enter your Name" value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />

                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label for="">Email Address<span className="red">*</span></label>  {errors.user_email && <p className="error-text">{errors.user_email}</p>}
                                             <input type="email" placeholder="Enter your Email Address" value={newData.user_email} onChange={(e) => setNewData({ ...newData, user_email: e.target.value })} />

                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label for="">Contact Number<span className="red">*</span></label> {errors.user_contact_number && <p className="error-text">{errors.user_contact_number}</p>}
                                             <input type="number" placeholder="Enter your Contact Number" value={newData.user_contact_number} onChange={(e) => setNewData({ ...newData, user_contact_number: e.target.value })} />

                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-12">
                                     
                                    <CitySelector
                                          newData={newData}
                                          setNewData={setNewData}
                                          fieldKey="user_city"
                                          errors={errors}
                                       />
                                    </div>
                                 </div>
                              </div>
                              <div className="space20"></div>
                              <div className="btn-group-2">
                                 <a className="theme-btn-3 btn-color" href="#" onClick={formPutPartenshipdeed}>Proceed now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                              </div>
                           </div>
                        </form>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space60 bg-white"></div>

         <div className="home4-counters bg-white">
            <div className="container">
               <div className="row">
                  <div className="col-md-12">


                     <HomeCounters />
                  </div>
               </div>

               <div className="row">


                  <div className="space40"></div>
                  <div className="col-lg-7">

                     <p className="pd-text">Expand your business with full legal protection by registering it as a Private Limited Company! A Private Limited Company is a privately owned business entity ideal for small businesses. It limits the liability of owners to their shareholdings, caps the number of shareholders to 200, and restricts shareholders from publicly trading shares, offering a secure and structured way to grow your business.</p>
                     <p className="pd-text">A Private Limited Company can have a minimum of 2 Directors and a maximum of 15 Directors. The registration process is governed by the Companies Act of 2013 and the Companies Incorporation Rules of 2014. Make your business official with Dm2Legal's Private Limited Company Registration services!</p>

                     <p className="pd-text">We offer a comprehensive package with easy documentation, fast registration, and a hassle-free experience, allowing you to focus on building and growing your business. Register your Private Limited Company today and start enjoying the benefits of a registered business name!</p>
                  </div>
                  <div className="col-lg-5">
                     <img src="assets/img/service/service7-main-image.png" alt="" />
                  </div>
               </div>
               <div className="space20"></div>

            </div>
         </div>

         <div className="space40 bg-white"></div>
         <div className="service-binifits9 sp0 last-section" id="service2" >
            <div className="space50"></div>
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <h2 className="text-center">Comparison </h2>
                        <div className="space40"></div>
                        <h6 className="hedaing-text">All Service Comparison</h6>
                        <h3 className="hedaing-text-1">Proprietorship vs Limited Liability Partnership (LLP) vs Company</h3>
                        <div className="pro-llp-com-table">
                           <table>
                              <thead>
                                 <tr className="table-heading">
                                    <th>Features</th>
                                    <th>Proprietorship</th>
                                    <th>Partnership</th>
                                    <th>LLP</th>
                                    <th>Company</th>
                                 </tr>
                              </thead>
                              <tbody>
                                 <tr>
                                    <td>Ownership</td>
                                    <td>In a proprietorship, a single individual owns and manages the entire business, making all decisions and retaining full control and responsibility for its operations.</td>
                                    <td>A partnership involves two or more individuals (partners) who share the ownership, management, and responsibilities of the business. Each partner contributes to the business, and profits and losses are typically shared based on the terms outlined in the partnership agreement.</td>
                                    <td>In a partnership, partners generally have unlimited liability, meaning their personal assets can be used to settle business debts or liabilities. This differs from structures like a limited liability company (LLC), where personal assets are protected.</td>
                                    <td>A company is a legal entity distinct from its owners (shareholders). Shareholders enjoy limited liability, meaning their personal assets are generally protected from the company's debts and liabilities.</td>
                                 </tr>
                                 <tr>
                                    <td>Definition</td>
                                    <td>A sole proprietorship is a business owned and operated by a single individual, who has full control over its operations and decisions.</td>
                                    <td>A partnership is a legal arrangement in which two or more individuals or entities come together to share ownership, responsibilities, profits, and liabilities of a business.</td>
                                    <td>An LLP (Limited Liability Partnership) is a hybrid business structure that combines aspects of both partnerships and companies. It provides limited liability to its partners, meaning their personal assets are protected from the business’s liabilities.</td>
                                    <td>A company is a legal entity distinct from its owners (shareholders). It can be structured as a private limited company or a public limited company. Shareholders are the owners of the company, and their liability is limited to their investment in the company.</td>
                                 </tr>
                                 <tr>
                                    <td>Registration Time</td>
                                    <td></td>
                                    <td></td>
                                    <td>7-15 working days</td>
                                    <td></td>
                                 </tr>
                                 <tr>
                                    <td>Promoter Liability</td>
                                    <td></td>
                                    <td>Unlimited Liability</td>
                                    <td></td>
                                    <td>Limited Liability</td>
                                 </tr>
                                 <tr>
                                    <td>Governance</td>
                                    <td>Governed by Local Laws</td>
                                    <td>Under Partnership Act, 1932</td>
                                    <td>LLP Act, 2008</td>
                                    <td>Under Companies Act,2013</td>
                                 </tr>
                                 <tr>
                                    <td>Compliance Requirements</td>
                                    <td>Compliance with Income Tax Laws and other local laws is essential for any business entity to operate legally and avoid penalties.</td>
                                    <td>Compliance with Income Tax Laws and other local laws is essential for any business entity to operate legally and avoid penalties.</td>
                                    <td>Compliance with Income Tax Laws, Local Laws, the Companies Act, and other applicable regulations is critical for businesses to operate within the legal framework and avoid penalties.</td>
                                    <td>Compliance with Income Tax Laws, Local Laws, the Companies Act, and other applicable regulations is critical for businesses to operate within the legal framework and avoid penalties.</td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                     </div>
                  </div>
                  <div className="space30"></div>
               </div>
            </div>
         </div>

         <div className="service-binifits9 sp0 bg-white" >
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space50"></div>
                        <h2 className="aos-init aos-animate text-center">How to apply</h2>
                        <div className="space20"></div>
                        <img src="assets/img/images/legal251-how-to-apply.png" alt="" />
                        <div className="space20"></div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div className="space20 bg-white"></div>

         <div className="last-section bg-white">
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space20"></div>
                        <h2 className="aos-init aos-animate text-center">Benefits </h2>
                     </div>
                  </div>
               </div>



               <div className="row">
                  <div className="col-lg-6">
                     <div className="hadding7">

                        <div className="space20"></div>


                        <div className="contact6-list">
                           <ul>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span><strong className='cstrong'>Separate legal entity</strong>
                                 <p className="pd-text">A company is considered a separate legal entity from its owners (shareholders). This concept is a fundamental characteristic of corporate law.</p>
                              </li>
                              <hr />
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span><strong className='cstrong'>More capital</strong>
                                 <p className="pd-text">A private limited company has the ability to raise more capital by issuing shares to its shareholders.</p>
                              </li>
                              <hr />
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span><strong className='cstrong'> Attracting investors</strong>

                                 <p className="pd-text">The structure of a private limited company is highly attractive to potential investors for several.</p>
                              </li>
                              <hr />
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span><strong className='cstrong'>Limited risk</strong>

                                 <p className="pd-text">In a private limited company, the concept of limited risk is one of the key benefits for shareholders.</p>
                              </li>
                              <hr />
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span><strong className='cstrong'>Legal protection</strong>

                                 <p className="pd-text">A company structure provides strong legal protection to both shareholders and directors, which is one of its primary advantages.</p>
                              </li>

                           </ul>
                        </div>


                     </div>
                  </div>

                  <div className="col-lg-6">
                     <div className="hadding7">

                        <div className="space20"></div>


                        <div className="contact6-list">
                           <ul>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span><strong className='cstrong'>Limited liability</strong>

                                 <p className="pd-text">Limited liability is a major benefit of forming a company because it protects shareholders' personal assets from the business’s financial troubles.</p>
                              </li>
                              <hr />
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span><strong className='cstrong'>Perpetual existence</strong>

                                 <p className="pd-text">Perpetual existence ensures that the company remains operational despite changes in ownership or management. </p>
                              </li>
                              <hr />
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span><strong className='cstrong'>Limited compliance</strong>

                                 <p className="pd-text">Limited compliance is one of the key advantages of forming a private limited company compared to a public limited company.</p>
                              </li>
                              <hr />
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span><strong className='cstrong'>Separate taxation</strong>

                                 <p className="pd-text">Separate taxation is one of the fundamental characteristics of a company structure. Unlike sole proprietorships or partnerships</p>
                              </li>
                              <hr />

                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span><strong className='cstrong'>Global expansion</strong>

                                 <p className="pd-text">A private limited company provides the structure and flexibility needed for businesses aiming for global expansion.</p>
                              </li>

                           </ul>
                        </div>


                     </div>
                  </div>
               </div>
               <div className="space20"></div>
            </div>
         </div>



         <Testimonials />

         <div className="service-binifits9 sp0" id="service2">
            <div className="container">
               <div className="row">
                  <div className="space20"></div>
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <h2 data-aos="fade-up" className="aos-init aos-animate text-center">Registration Process</h2>
                        <h4 data-aos="fade-up" className="aos-init aos-animate text-center  ">Private Limited Company Registration</h4>
                        <div className="space20"></div>
                        <img src="assets/img/images/Group-8586.png" alt="" />
                     </div>
                  </div>
                  <div className="space20"></div>
               </div>
            </div>
         </div>


         <div className="bg-white">

            <div className="container">
               <div className="row">
                  <div className="col-12">
                     <div className="faq-items" id="masonry-grid">
                        <div className="mesonry-item general single-price-list">
                           <div className="faqs inner-faq">
                              <h2 className="text-center">FREQUENTLY ASKED QUESTIONS</h2>
                              <div className="space30"></div>
                              <div id="general">
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 1 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(1)}
                                    >
                                       Q1: What does it mean to have a Private Limited Company?
                                       <span>
                                          {activeQuestion === 1 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 1 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          A Private Limited Company (Pvt Ltd) is a business structure where ownership is restricted to a specific number of shareholders, and liability is limited to their shareholding. This means that the personal assets of the owners are protected from company debts. It operates as a separate legal entity, enjoys perpetual succession, and has restrictions on publicly trading shares. This type of company is ideal for startups and small to medium-sized businesses seeking legal protection and credibility.
                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 2 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(2)}
                                    >
                                       Q2: What are the essential criteria for registering a Private Limited Company in India?
                                       <span>
                                          {activeQuestion === 2 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 2 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       To register a Pvt Ltd Company in India, you need 2 directors, 2 shareholders (max 200), DIN & DSC, a unique name, a registered office, and MoA & AoA. There’s no minimum capital, but an initial amount must be declared. Registration is done via SPICe+ on the MCA portal, including PAN & TAN. Once approved, the company can start operations. 🚀
                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 3 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(3)}
                                    >
                                       Q3: How much capital is needed to start a Private Limited Company?
                                       <span>
                                          {activeQuestion === 3 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 3 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          There is no minimum capital requirement to register a Private Limited Company in India. However, businesses usually declare an initial authorized capital of ₹1 lakh for compliance purposes.
                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 4 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(4)}
                                    >
                                       Q4: What are the steps and time required to register a Private Limited Company?

                                       <span>
                                          {activeQuestion === 4 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 4 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">The Private Limited Company registration process in India includes:</p>
                                       <ul>
                                          <li>Obtain DSC & DIN – Digital signatures and director identification. (1-2 days)</li>
                                          <li>Name Approval – Apply via MCA’s RUN service. (1-2 days)</li>

                                          <li>Draft MoA & AoA – Prepare company documents. (1-2 days) </li>
                                          <li>File SPICe+ Form – Submit incorporation application. (2-3 days) </li>
                                          <li>PAN & TAN Registration – Applied along with incorporation. (1-2 days) </li>
                                          <li>Certificate of Incorporation (COI) – Issued by MCA. (3-5 days) </li>
                                       </ul>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 5 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(5)}
                                    >
                                       Q5: Can a Private Limited Company have a residential address as its registered office?
                                       <span>
                                          {activeQuestion === 5 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 5 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          Yes, a Private Limited Company in India can use a residential address as its registered office. The MCA allows businesses to register at a home address as long as they provide valid address proof (such as an electricity bill, rental agreement, or NOC from the owner). The registered office must be capable of receiving official communication from government authorities.
                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 6 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(6)}
                                    >
                                       Q6: What are the mandatory annual compliance requirements for a Private Limited Company?
                                       <span>
                                          {activeQuestion === 6 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 6 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          Annual Compliance Requirements for a Private Limited Company: MGT-7 – File annual return with ROC.
                                          AOC-4 – Submit financial statements,
                                          ITR-6 – File income tax return,
                                          Statutory Audit – Mandatory CA audit,
                                          Board Meetings – Minimum 4 per year,
                                          AGM – Required if multiple shareholders,
                                          DIR-3 KYC – Director KYC update,
                                          DPT-3 – Declare loans/deposits.
                                       </p>
                                    </div>
                                 </div>

                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 7 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(7)}
                                    >
                                       Q7: Can a Private Limited Company be converted into another business entity later?
                                       <span>
                                          {activeQuestion === 7 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 7 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       Yes, a Private Limited Company can be converted into other business entities such as a Public Limited Company, LLP (Limited Liability Partnership), or One Person Company (OPC) based on business requirements. The conversion process involves obtaining shareholder approval, complying with legal formalities, and filing necessary forms with the Ministry of Corporate Affairs (MCA). Each type of conversion has specific eligibility criteria and regulatory requirements. 🚀
                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 8 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(8)}
                                    >
                                       Q8: What are the tax implications for a Private Limited Company in India?
                                       <span>
                                          {activeQuestion === 8 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 8 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       A Private Limited Company in India pays 22% corporate tax (15% for new manufacturers) and 15% MAT if applicable. Dividends are taxed in shareholders' hands. GST registration is mandatory above ₹20L (services) or ₹40L (goods). Companies must deduct TDS, pay advance tax, and undergo a tax audit if turnover exceeds ₹10Cr (business) or ₹50L (profession). Non-compliance leads to penalties.
                                       </p>
                                    </div>
                                 </div>













                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space40 bg-white"></div>

         <div className="last-section bg-white">
            <div className="container">
               <div className="row">
                  <div className="col-lg-7 m-auto text-center">
                     <div className="hadding7">
                        <div className="space20"></div>
                        <h2 className="aos-init aos-animate">Why choose Dm2Legal to Register a Partnership Firm</h2>
                     </div>
                  </div>
               </div>
               <div className="space30"></div>
               <div className="row">
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>1</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4> <span><img className="arow" src="assets/image/icons/growth.svg" alt="" /></span><a href="single-service-1.html" >Growth & Improvement</a></h4>
                           <p>We are committed to continuous growth and improvement. To us, growth is the fundamental principle of life, and we strive to achieve it. We understand the significance of business growth and its importance to you.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>2</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >Support & Availability</a></h4>
                           <p>We understand how even a small problem or query can cause frustration. That's why we are always available to provide support and resolve any issues you may have, whenever they arise.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>3</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                           <p>Our team consists of experienced professionals who prioritize professionalism and customer satisfaction above all else. Each member is passionate about their respective field and dedicated to delivering the best service.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>4</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/focus.svg" alt="" /></span><a href="single-service-1.html" >Focus</a></h4>
                           <p>We treat every task with the utmost importance. Our team members remain dedicated and focused on addressing even the smallest needs and requirements of our clients.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>5</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/value.svg" alt="" /></span><a href="single-service-1.html" >Value for Money</a></h4>
                           <p>We understand the value of your hard-earned money. That's why we ensure that every penny you invest with us is utilized in the most effective way, delivering the best value for your investment.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>6</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/care.svg" alt="" /></span><a href="single-service-1.html" >Care & Regards</a></h4>
                           <p>We consider you a part of our family, and your challenges and successes are our own. Your interests are our priority, and we are dedicated to fulfilling them with the utmost care and attention.</p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space40 bg-white"></div>

         <WhatsAppScrollButton />

         <Footer />
         <CircularScrollProgress />
      </div>

   );
}
export default Pvtltdcompanyregistration;